import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useRuntimeConfig } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
	window.Pusher = Pusher;

	let echo = new Echo({
	    broadcaster: 'pusher',
	    key: useRuntimeConfig().public.pusherAppKey,
	    cluster: "eu",
	    forceTLS: true
	})

	nuxtApp.provide('echo', echo);
});